import emoji from "react-easy-emoji";

import kyrance from "./assets/img/icons/common/kyrance.png";
import nova from "./assets/img/icons/common/nova.jfif";


export const greetings = {
    title: "Hi all, I'm Gnanod Chathuramdu",
    description: "As a reliable, dedicated, well-organized individual with the experience of developing projects with the use of emerging technologies. I am an energetic and ambitious person who has developed a responsible approach to any task that I undertake, or situation that I am presented with and also looking forward to use my analytical skills and knowledge for organizational growth while allowing me to grow professionally.",
    resumeLink: "",
};

export const openSource = {
    githubUserName: "Gnanod",
};

export const contact = {};

export const socialLinks = {
    // facebook: "",
    // instagram: "",
    github: "https://github.com/Gnanod",
    linkedin: "https://www.linkedin.com/in/gnanod-chathuramadu-379847130/",
};

export const skillsSection = {
    title: "What I do",
    subTitle:
        "FULL STACK DEVELOPER WHO WANTS TO EXPLORE EVERY TECH STACK",
    skills: [],

    softwareSkills: [
        {
            skillName: "html-5",
            fontAwesomeClassname: "vscode-icons:file-type-html",
        },
        {
            skillName: "css3",
            fontAwesomeClassname: "vscode-icons:file-type-css",
        },
        {
            skillName: "JavaScript",
            fontAwesomeClassname: "logos:javascript",
        },
        {
            skillName: "TypeScript",
            fontAwesomeClassname: "logos:typescript-icon",
        },
        {
            skillName: "reactjs",
            fontAwesomeClassname: "vscode-icons:file-type-reactjs",
        },
        {
            skillName: "nodejs",
            fontAwesomeClassname: "logos:nodejs-icon",
        },
        // {
        // 	skillName: "flutter",
        // 	fontAwesomeClassname: "logos:flutter",
        // },
        {
            skillName: "npm",
            fontAwesomeClassname: "vscode-icons:file-type-npm",
        },
        {
            skillName: "javaSwing",
            fontAwesomeClassname: "logos:java",
        },
        {
            skillName: "sql-database",
            fontAwesomeClassname: "vscode-icons:file-type-sql",
        },
        {
            skillName: "mongoDB",
            fontAwesomeClassname: "vscode-icons:file-type-mongo",
        },
        {
            skillName: "aws",
            fontAwesomeClassname: "logos:aws",
        },
        {
            skillName: "javaFx",
            fontAwesomeClassname: "logos:java",
        },
        {
            skillName: "firebase",
            fontAwesomeClassname: "logos:firebase",
        },
        {
            skillName: "python",
            fontAwesomeClassname: "logos:python",
        },
        {
            skillName: "git",
            fontAwesomeClassname: "logos:git-icon",
        },
        {
            skillName: "java",
            fontAwesomeClassname: "logos:java",
        },
        {
            skillName: "mysql",
            fontAwesomeClassname: "logos:mysql",
        },
        {
            skillName: "springboot",
            fontAwesomeClassname: "logos:spring",
        },
        {
            skillName: "Flask",
            fontAwesomeClassname: "logos:flask",
        },
        {
            skillName: "CodeIgniter",
            fontAwesomeClassname: "logos:codeigniter",
        },
        {
            skillName: "Postman",
            fontAwesomeClassname: "logos:postman",
        },
        {
            skillName: "Angular8",
            fontAwesomeClassname: "logos:angular",
        },
        // {
        // 	skillName: "docker",
        // 	fontAwesomeClassname: "logos:docker-icon",
        // },
    ],
};

export const SkillBars = [
    {
        Stack: "Frontend/Design", //Insert stack or technology you have experience in
        progressPercentage: "75", //Insert relative proficiency in percentage
    },
    {
        Stack: "Backend",
        progressPercentage: "85",
    }
];

export const educationInfo = [
    {
        schoolName: "SLIIT | Sri Lanka Institute of Information Technology",
        subHeader: "BSc (Hons) in Information Technology Specializing in Software Engineering",
        duration: "February 2018 - November 2021",
        // desc: "Participated in the research of XXX and published 3 papers.",
        // descBullets: [
        // 	"Lorem ipsum dolor sit amet, consectetur adipdfgiscing elit",
        // 	"Lorem ipsum dolor sit amet, consectetur adipiscing elit",
        // ],
    },
    {
        schoolName: "IJSE-Institute of Software Engineering",
        subHeader: "Diploma in Software Engineering,computer Software Engineering",
        duration: "September 2016 - November 2017",
        // desc: "Participated in the research of XXX and published 3 papers.",
        // descBullets: [
        // 	"Lorem ipsum dolor sit amet, consectetfgur adipiscing elit",
        // 	"Lorem ipsum dolor sit amet, consectetur adipiscing elit",
        // ],
    },
    {
        schoolName: "G/Christ Church Boys' College",
        subHeader: "General Certificate Of Education Advanced Level ",
        duration: " 2001 -  2014",
        // desc: "Ranked top 10% in the program. Took courses about Software Engineering, Web Security, Operating Systems, ...",
        // descBullets: [
        // 	"Lorem ipsum dolorfdg sit amet, consectetur adipiscing elit",
        // ],
    },
];

export const experience = [
    {
        role: "Intern Software Engineer",
        company: "Kyrance technologies",
        companylogo: kyrance,
        date: " November 2019 – May 2020",
        descBullets: [
            "Used PHP Codeignitor Web framework to develop ERP solution for automobile company",
            "Handled client requirements with exposure",
            "Met my long term and short term goals",
            "Helped management to find work flow issues and came up with solutions",
        ],
    },
    {
        role: "Project based Software Devevloper",
        company: "Nova Solutions",
        companylogo: nova,
        date: " May 2020 – June 2021",
        descBullets: [
            "Completed 3 projects related to vehicle service management system(both front end and backend development) e learning system(backend development) and apartment management system (frontend)",
            "Used Angular8 framework for frontend development",
            "Used spring boot framework for backend development",
            "Database integration has done using MySQL",
            "Gathered real client requirements and analyzed them appropriately",
        ],
    },
];

export const projects = [
    {
        name: "CocoRemedy (Final year research project) ",
        desc: "Coco Remedy is the first mobile and web-based application that provide surveillance and identification of coconut diseases and pest infestations for the people of Sri Lanka. The research was conducted with the collaboration of Coconut Research Institute of Sri Lanka (CRISL).",
        duration:"Present",
		link: "https://www.youtube.com/watch?v=iMz36a_Xbi0&list=PLYMLC0vkIKJmmj7MTlm7y_Kxd0EDMrOQ5",
        technology: [
            {
                skillName: "reactjs",
                fontAwesomeClassname: "vscode-icons:file-type-reactjs",
            },
            {
                skillName: "nodejs",
                fontAwesomeClassname: "logos:nodejs-icon",
            },
            {
                skillName: "express",
                fontAwesomeClassname: "logos:express",
            },
            {
                skillName: "mongoDB",
                fontAwesomeClassname: "vscode-icons:file-type-mongo",
            },
            {
                skillName: "firebase",
                fontAwesomeClassname: "logos:firebase",
            },
            {
                skillName: "react-native",
                fontAwesomeClassname: "logos:react",
            },
            {
                skillName: "aws",
                fontAwesomeClassname: "logos:aws",
            },
        ],
    },
    {
        name: "Time Table Management System",
		duration:"Jul 2020 – Nov 2020",
        desc: "This project-based on preparing a timetable management system for ABC non-state degree awarding institute.we have developed a desktop application for managing the timetables of the ABC institute Using javaFx.",
        github: "https://github.com/Gnanod/TimeTableManagementProjectSPM.git",
        technology: [
            {
                skillName: "java",
                fontAwesomeClassname: "logos:java",
            },
            {
                skillName: "mysql",
                fontAwesomeClassname: "logos:mysql",
            },
            {
                skillName: "javaFx",
                fontAwesomeClassname: "logos:java",
            }
        ],
    },
	{
		name: "Alarm Monitor System",
		duration:"Apr 2020 – Jun 2020",
		desc: "Alarm Monitoring System is a web application where users are able to view all fire alarm sensor status. It is implemented by using technologies such as ReactJS for the frontend, spring boot for the backend. The system is a combination of a website and a REST API which is accompanied by an MYSQL database. A User can view the status of all fire alarm sensors and for each sensor, the system displays whether the fire alarm sensor is active, the location, smoke level and the CO2 level. If the smoke level is above 5 then the colour of the chart is changed. Every 40 seconds the sensor details will update. The system will automatically generate alerts (Desktop Application and Web Application), SMS and emails when CO2 and smoke levels are above 5. SMS and emails will be sent to the user. In the RMI server, there are security mechanisms like email validations, password validations and numerical validations. Also, the username, password are encoded in the RMI server and decoded in REST API.",
		github: "https://github.com/Gnanod/AlarmMoniterSystem.git",
		link: "https://www.youtube.com/watch?v=7RKFPz5qWNI",
		technology: [
			{
				skillName: "reactjs",
				fontAwesomeClassname: "vscode-icons:file-type-reactjs",
			},
			{
				skillName: "nodejs",
				fontAwesomeClassname: "logos:nodejs-icon",
			},
			{
				skillName: "express",
				fontAwesomeClassname: "logos:express",
			},
			{
				skillName: "RMI",
				fontAwesomeClassname: "logos:java",
			},
			{
				skillName: "mysql",
				fontAwesomeClassname: "logos:mysql",
			},
			{
				skillName: "javaSwing",
				fontAwesomeClassname: "logos:java",
			}
		],
	},
	{
		name: "Online Fashion Store",
		desc: "Online shopping cart system for a fashion store\" called GSTD Fashions, is an immersive software application for online shopping. The system supports the three roles namely user roles, the role of administrator and the role of store manager. The administrator is allowed to create categories and to add to the system store mangers. Two types of administers names Admin and Store Manager is responsible in handling the GSTD web application. Anyone can view products as a guest even without login to the system. But, only users who have logged into the system are allowed to place orders.\n" +
			"The admin can add new admins as well as store managers into the system. Admin as an item management role can create categories for the products while the store manager\n" +
			"can add products with details to the relevant category with discounts. Through user management users are given the facility to add products to the shopping cart as well as purchase the selected products in the shopping cart by selecting the payment method (card/cash on delivery, etc.).They can create a wish list and rate the displayed products as well. The system is developed using prop",
		duration: "Feb 2020 – Jun 2020",
		github: "https://github.com/Gnanod/OnlineFashionStore.git",
		link: "https://www.youtube.com/watch?v=ZcW2shrUyrA",
		technology: [
			{
				skillName: "reactjs",
				fontAwesomeClassname: "vscode-icons:file-type-reactjs",
			},
			{
				skillName: "nodejs",
				fontAwesomeClassname: "logos:nodejs-icon",
			},
			{
				skillName: "express",
				fontAwesomeClassname: "logos:express",
			},
			{
				skillName: "mongoDB",
				fontAwesomeClassname: "vscode-icons:file-type-mongo",
			},
			{
				skillName: "aws",
				fontAwesomeClassname: "logos:aws",
			},
            {
                skillName: "springboot",
                fontAwesomeClassname: "logos:spring",
            },
            {
                skillName: "java",
                fontAwesomeClassname: "logos:java",
            }
		],
	},
    {
        name: "Guru App",
        desc: "This is a android based mobile application.This project targeting four components.User Management,Student Management,Fee Management and" +
            "Exam Marks Management",
        duration: "Jul 2019 – Nov 2019",
        github: "https://github.com/Gnanod/MadProject.git",
        technology: [
            {
                skillName: "Android",
                fontAwesomeClassname: "logos:android",
            },
            {
                skillName: "java",
                fontAwesomeClassname: "logos:java",
            },
            {
                skillName: "sqlLite",
                fontAwesomeClassname: "vscode-icons:file-type-sql",
            },
        ],
    },
    {
        name: "Retail and WholeSale Management System",
        desc: "This web application helps to manage vehicle services and fuel management for users in-vehicle service centre.\n",
        duration: "Jun 2019 – Nov 2019\n" +
            "\n",
        github: "https://github.com/Gnanod/RetailAndWholeSaleManagementSystem.git",
        technology: [
            {
                skillName: "Angular8",
                fontAwesomeClassname: "logos:angular",
            },
            {
                skillName: "SpringBoot",
                fontAwesomeClassname: "logos:spring",
            },
            {
                skillName: "Mysql",
                fontAwesomeClassname: "logos:mysql",
            },
        ],
    },
    {
        name: "Vehicle Services And Fuel Management System",
        desc: "This web application helps to manage vehicle services and fuel management for users in-vehicle service centre.",
        duration: "Feb 2019 – Jun 2019",
        github: "https://github.com/Gnanod/VehicleServicesAndFuelManagement-System.git",
        technology: [
            {
                skillName: "html-5",
                fontAwesomeClassname: "vscode-icons:file-type-html",
            },
            {
                skillName: "java",
                fontAwesomeClassname: "logos:java",
            },
            {
                skillName: "css3",
                fontAwesomeClassname: "vscode-icons:file-type-css",
            },
            {
                skillName: "Jsp_servlet",
                fontAwesomeClassname: "logos:java",
            },
            {
                skillName: "Mysql",
                fontAwesomeClassname: "logos:mysql",
            },
            {
                skillName: "JDBC",
                fontAwesomeClassname: "logos:java",
            },
        ],
    },
    {
        name: "Pure Chess Game",
        desc: "Without using any chess game engine, I have developed this program using only\n" +
            "HTML | jQuery\n" +
            "jQuery , Bootstrap\n" +
            "Bootstrap | CSS\n" +
            "Git | GitHub",
        duration: "Sep 2017",
        github: "https://github.com/Gnanod/VehicleServiceCenter.git",
        link: "https://youtu.be/WF4puScJvXQ",
        technology: [
            {
                skillName: "html-5",
                fontAwesomeClassname: "vscode-icons:file-type-html",
            },

            {
                skillName: "css3-Bootstrap",
                fontAwesomeClassname: "vscode-icons:file-type-css",
            },
            {
                skillName: "JavaScript-Jquery",
                fontAwesomeClassname: "logos:javascript",
            },

        ],
    },
    {
        name: "Railway Ticket Reservation System",
        desc: "This Project is a Java based train ticket and seat reservation system .This project allows to book seats  in a few easy " +
            "steps also can manage train schedules",
        duration: "July 2017 – Nov 2017",
        github: "https://github.com/Gnanod/VehicleServiceCenter.git",
        technology: [
            {
                skillName: "java",
                fontAwesomeClassname: "logos:java",
            },

            {
                skillName: "Mysql",
                fontAwesomeClassname: "logos:mysql",
            },
            {
                skillName: "Java-Swing",
                fontAwesomeClassname: "logos:java",
            },
            {
                skillName: "Hibernate",
                fontAwesomeClassname: "logos:hibernate",
            },
            {
                skillName: "Java-RMI",
                fontAwesomeClassname: "logos:java",
            },
        ],
    },
    {
        name: "FoodCity Management Sytem(POS)\n",
        desc: "This Project is a Java based Food City Management System.This project allows to Manage Orders,Users,Stock Details and Payments",
        duration: "April 2017 – May 2017",
        github: "https://github.com/Gnanod/Supermarket-Management-System",
        technology: [
            {
                skillName: "java",
                fontAwesomeClassname: "logos:java",
            },
            {
                skillName: "Java-Swing",
                fontAwesomeClassname: "logos:java",
            },
            {
                skillName: "Mysql",
                fontAwesomeClassname: "logos:mysql",
            },
            {
                skillName: "JDBC",
                fontAwesomeClassname: "logos:java",
            },
        ],
    }

];

export const feedbacks = [
    // {
    //     name: "Hassan Mehmood",
    //     feedback:
    //         "We have been very happy with our new website! It looks professional and very easy to navigate. Our experience with the customer service at Hanzla tauqeer has been great. They handle things very efficiently and are available for any questions we have. They also keep us updated on daily reports so we know how our site is doing. I would recommend that u have choose hanzla web developer services for u.",
    // },
    // {
    //     name: "Maheen Altaf",
    //     feedback:
    //         "the website is very nice, everything was perfectly made as i need. it just loads in moments, without giving u the chance to wait. the quality is also very amazing. i am using it without any problem. great job",
    // },
];
